import { Enrollee } from "pmt-types/src/models/Enrollee.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationUpsertEnrollee = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (enrollee: Enrollee) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/enrollees`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
          body: JSON.stringify(enrollee),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to upsert enrollee");
      }

      return (await response.json()) as Enrollee;
    },
    {
      onError: (error, data) => {
        console.error("Failed to upsert enrollee", error, data);
      },
    },
  );
};
